import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _CloseRound(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M18 6 6 18M6 6l12 12" })));
}
const CloseRound = forwardRef(_CloseRound);
export { CloseRound };
